import axios from "@util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

export const getAllMailDomain = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/email-maildomain/all`,
      headers: {
         Accept: "*/*"
      }
   });
};
export const getMailDomain = async (domain) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email-maildomain?simpleName=${domain}`,
      headers: {
         Accept: "*/*"
      }
   });
};
export const getUserMailbox = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/email-mailbox`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const deleteUserMailbox = async (userId, mailboxId) => {
   return axios({
      method: "delete",
      url: `${hostCloud}/email-mailbox?mailBoxId=${mailboxId}`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const getGmailApprovalPromptUrl = async (oauthMailBoxType) => {
   return axios({
      method: "get",
      url: `${hostCloud}/email-mailbox/oauth-prompt-url?oauthMailBoxType=${oauthMailBoxType}`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const analyzeMails = async (mailboxId, listOfStringId) => {
   return axios({
      method: "post",
      url: `${hostCloud}/email/message/analyze-mails`,
      headers: {
         Accept: "*/*"
      },
      data: {
         mailboxId: mailboxId,
         messagesIds: listOfStringId
      }
   });
};

export const createCase = async (mailboxId, messageId, configId, dataId, dataModelName) => {
   return axios({
      method: "post",
      url: `${hostCloud}/email/message/create-case`,
      headers: {
         Accept: "*/*"
      },
      data: {
         mailboxId: +mailboxId,
         messageId: messageId,
         configId: +configId,
         dataId: dataId,
         dataModelName: dataModelName
      }
   });
};

export const sendEmailMailbox = async (mailDomain, password, userName, rsaData) => {
   return axios({
      method: "post",
      url: `${hostCloud}/email-mailbox`,
      headers: {
         Accept: "*/*"
      },
      data: {
         mailDomainId: mailDomain.id,
         password: password,
         username: userName,
         rsaDataId: rsaData
      }
   });
};

//api.bp2.cloud:8443/bpower2newsletter/email-mailbox/gmail?userId=ok&username=ok&urlWithCode=ok
export const sendEmailMailboxGmail = async (urlWithCode, oauthMailBoxType) => {
   return axios({
      method: "post",
      url: `${hostCloud}/email-mailbox/oauth?oauthMailBoxType=${oauthMailBoxType}`,
      headers: {
         Accept: "*/*"
      },
      params: { urlWithCode: urlWithCode }
   });
};
export const connectMailboxGmail = async (urlWithCode, oauthMailBoxType) => {
   return axios({
      method: "post",
      url: `${hostCloud}/email-mailbox/oauth?oauthMailBoxType=${oauthMailBoxType}`,
      headers: {
         Accept: "*/*"
      },
      params: { urlWithCode: urlWithCode }
   });
};
export const getPublicKey = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/rsa?platform=CLOUD`,
      headers: {
         Accept: "*/*"
      }
   });
};

export const addComment = async ({ msgId = null, instId }, comment) => {
   // 1. <div> is not working, use <span>
   // 2. " is not working, use ' instead
   const url = `${hostCloud}/legacy/request`;
   const params = {
      ...(msgId ? { msgId } : { instId })
   };
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json"
      },
      data: {
         endpoint: "/workflow/method/addComment",
         httpMethod: "POST",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
         body: `{\"text\":\"${comment}\"}` //eslint-disable-line
      }
   }).then((res) => {
      return res;
   });
};
